'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('SleepNeedsCtrl', SleepNeedsCtrl);

  SleepNeedsCtrl.$inject = ['$stateParams', 'activitySvc', 'onboardingRouter', 'sleepCheckInSvc', 'eventTrackingSvc'];

  function SleepNeedsCtrl($stateParams, activitySvc, onboardingRouter, sleepCheckInSvc, eventTrackingSvc) {
    var vm = this;
    vm.$onInit = activate;

    vm.next = _navigate;
    vm.context = onboardingRouter.getContext();
    vm.weeklyCheckIn = {
      id: $stateParams.cid
    };

    if (onboardingRouter.getRequirement('SLEEP_NEEDS')) {
      vm.activity = onboardingRouter.getRequirement('SLEEP_NEEDS').data;
      vm.quiz = vm.activity.sections[0];
    }

    /////////////////
    function _navigate(checkIn) {
      if (!checkIn) {
        vm.weeklyCheckIn.checkInStatus = 'SKIP';
        sleepCheckInSvc.saveCheckIn(vm.weeklyCheckIn).then(function (resp) {
          // if sleep needs is skipped, skip SLEEP_NEEDS and SLEEP_PLAN.  mark all complete.
          onboardingRouter.markRequirementComplete('sleep.schedule');
          onboardingRouter.markRequirementComplete('sleep.plan');
          onboardingRouter.goToNextStep({ cid: resp }, {
            name: 'onboarding.mood.overlay'
          });
        });
      } else {
        //TODO - check for schedule need
        onboardingRouter.navigateSleepSchedule({
          cid: vm.weeklyCheckIn.id
        }, {
          name: 'onboarding.mood.overlay'
        });
      }
    }

    function activate() {}

    vm.save = function (score) {
      activitySvc.saveResponses(vm.activity).then(function (id) {
        var quizScore = {
          activityResponseId: id,
          activitySectionId: vm.quiz.id,
          score: score
        };
        activitySvc.saveQuizScore(quizScore).then(function (resp) {
          quizScore.id = resp;
          vm.weeklyCheckIn.quizScore = quizScore;
          vm.weeklyCheckIn.checkInStatus = 'STARTED';
          saveCheckin();
        });
      });
    };

    function saveCheckin() {
      eventTrackingSvc.fireEvent('sleepTool', 'weeklyCheckin', "sleepNeedQuestionnaireSaved");
      sleepCheckInSvc.saveCheckIn(vm.weeklyCheckIn).then(function (id) {
        vm.weeklyCheckIn.id = id;
        vm.next(vm.weeklyCheckIn);
      });
    }
  }
})();